export default __webpack_public_path__ + "static/media/comet-logo.8d2a702a.svg";